<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>
        <!-- lblAddAppointment -->
        lblTecRmiLabour
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="OnDismiss()" aria-label="Center Align">
        <span aria-hidden="true">
            ×
        </span>
    </button>
</div>
<div class="modal-body p-0  min-h500">
    <div class="card pad15">
        <div class="row justify-content-between" *ngIf="currentVehicleDetails">
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblRegNumber</label>
                    <div class="lbl-info">
                        <div class="flmid">
                            <div class="licplate LPNo d-flex"><span class="icn-flag"></span>
                                {{appointmentDetails.licensePlate}} </div>
                            <div class="imgWid">
                                <img af-brand-logo data-type="BRAND" [data-code]="appointmentDetails.brandCode" class="{{appointmentDetails.brand.name}}-icon common brandicon" alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblMake</label>
                    <div class="lbl-info"> {{currentVehicleDetails.companyMakeName}} </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblModel</label>
                    <div class="lbl-info"> {{currentVehicleDetails.companyModel}} </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblEngineNo</label>
                    <div class="lbl-info"> {{currentVehicleDetails.mchCode}}</div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblVinNumber</label>
                    <div class="lbl-info"> {{currentVehicleDetails.chassisNo}} <button placement="top"
                            ngbtooltip="Copy VIN" aria-label="Center Align" class="btn btn-link ml-2"
                            ng-reflect-placement="top" ng-reflect-ngb-tooltip="Copy VIN"><em
                                class="fas fa-copy fa-lg"></em></button>

                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblMileage</label>
                    <div class="lbl-info ng-star-inserted"> {{currentVehicleDetails.mileage}} &nbsp;KM </div>

                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblFuelType</label>
                    <div class="lbl-info"> {{currentVehicleDetails.fuelType}} </div>
                </div>
            </div>
        </div>

    </div>
    <div class=" min-h250">
        <ul class="nav-tabs nav">
            <li *ngFor="let tab of tabs" class="nav-item">
                <ng-container *ngIf="tab">
                    <a translate class="nav-link" (click)="selectedtab=tab.id"
                        [ngClass]="{'active': selectedtab==tab.id}">{{tab.name}}</a>
                </ng-container>
            </li>
        </ul>
        <div class="ctm-tab custom-card">
            <ng-cotainer *ngIf="selectedtab==1">
                <div class="pad15 ctm-tab custom-card">
                    <div class="card-accord">
                        <ngb-accordion #a="ngbAccordion" activeIds="first">
                            <ngb-panel id="first">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="d-flex align-items-center">
                                        <button ngbPanelToggle translate
                                            class="btn d-flex w-100 align-items-center text-left"
                                            aria-label="Center Align" translate>
                                            lblSelectLabour
                                            <ng-container *ngIf="!a.activeIds.includes('first')"><em
                                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                            </ng-container>
                                        </button>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div class="mb-2 row d-flex flex-column">
                                        <div class="d-flex flex-row" *ngFor="let work of labourWorkList">
                                            <div class="flexbox form-check pl-0 mt-2">
                                                <input type="radio" class=" " name="labourWorkList"
                                                    (change)="ManageLabourWorkListInStep1($event,work)"
                                                    [checked]='work.isSelected' />
                                                <label class="form-check-label" [for]="work.workId">{{work.nodeName}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>
                    </div>
                </div>
            </ng-cotainer>

            <ng-cotainer *ngIf="selectedtab==2">
                <div class="pad15 ctm-tab custom-card">
                    <div class="card-accord">
                        <ngb-accordion #a="ngbAccordion" activeIds="first">
                            <ngb-panel id="first">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="d-flex align-items-center">
                                        <button ngbPanelToggle translate
                                            class="btn d-flex w-100 align-items-center text-left"
                                            aria-label="Center Align" translate>
                                            lblSelectLabour
                                            <ng-container *ngIf="!a.activeIds.includes('first')"><em
                                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                            </ng-container>
                                        </button>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div class="mb-2 row d-flex flex-column">
                                        <div class="d-flex flex-row"
                                            *ngFor="let work of selectedLabourWorkFromStep1[0].childNodes">
                                            <div class="flexbox form-check pl-0 mt-2">
                                                <input type="radio" class=" " name="labourWorkList"
                                                    (change)="ManageLabourWorkListInStep2($event,work)"
                                                    [checked]='work.isSelected' />
                                                <label class="form-check-label" [for]="work.workId">{{work.nodeName}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>
                    </div>
                </div>
            </ng-cotainer>

            <ng-cotainer *ngIf="selectedtab==3">
                <div class="pad15 ctm-tab custom-card">
                    <div class="card-accord">
                        <ngb-accordion #a="ngbAccordion" activeIds="second">
                            <ngb-panel id="second">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="d-flex align-items-center">
                                        <button ngbPanelToggle translate
                                            class="btn d-flex w-100 align-items-center text-left"
                                            aria-label="Center Align" translate>
                                            lblSelectLabourService
                                            <ng-container *ngIf="!a.activeIds.includes('second')"><em
                                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                            </ng-container>
                                            <ng-container *ngIf="a.activeIds.includes('second')"><em
                                                    class="fas fa-angle-up fa-lg ml-auto"></em>
                                            </ng-container>
                                        </button>
                                    </div>
                                </ng-template>

                                <ng-template ngbPanelContent>
                                    <div class="mb-2 row d-flex flex-column">
                                        <div class="d-flex flex-row"
                                            *ngFor="let work of selectedLabourWorkFromStep2[0].childNodes">
                                            <div class="flexbox form-check pl-0 mt-2">
                                                <input type="radio" class=" " name="labourWorkList"
                                                    (change)="ManageLabourWorkListInStep3($event,work)"
                                                    [checked]='work.isSelected' />
                                                <label class="form-check-label" [for]="work.workId">{{work.nodeName}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ngb-panel>

                        </ngb-accordion>
                    </div>
                </div>
            </ng-cotainer>

            <!--Exclusive Service Selection -->
            <ng-cotainer *ngIf="selectedtab==4">
                <div class="pad15 ctm-tab custom-card">
                    <div class="card-accord">
                        <ngb-accordion #a="ngbAccordion" activeIds="first">
                            <ngb-panel id="first">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="d-flex align-items-center">
                                        <button ngbPanelToggle translate
                                            class="btn d-flex w-100 align-items-center text-left"
                                            aria-label="Center Align" translate aria-expanded="true">
                                            lblSelectExclusiveLabourService
                                            <ng-container *ngIf="!a.activeIds.includes('first')"><em
                                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                            </ng-container>
                                            <ng-container *ngIf="a.activeIds.includes('first')"><em
                                                    class="fas fa-angle-up fa-lg ml-auto"></em>
                                            </ng-container>
                                        </button>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div class="row" *ngIf="workSteps">

                                        <div class="col-12 py-3 border-bottom" *ngFor="let item of workSteps">
                                            <div class="flexbox form-check pl-0 mt-2">
                                                <input type="checkbox" class="radio-custom" name="work"
                                                    [id]="item.itemMpId" [value]="item.workId"
                                                    [(ngModel)]="item.isSelected"
                                                    (change)="ServiceSelectionInStep4($event,item)" />
                                                <label class="title16 text-uppercase mx-2"
                                                    [for]="item.workId">{{item.workText}}</label>

                                                <button type="button" style="float: right;"
                                                    class="btn btn-outline-primary ml-auto float-end"
                                                    (click)="getParts(item)" translate>
                                                    <em class="mr5 fas fa-toolbox"></em>
                                                    lblGetParts</button>
                                            </div>

                                            <div class="mt-3 mb-3 "
                                                *ngIf="item.exclusiveWorkPositions && item.exclusiveWorkPositions.length > 0">
                                                <h4 class="mb-2 title14 px-3" translate>Contains</h4>
                                                <div class="flexbox form-check"
                                                    *ngFor="let exclWork of item.exclusiveWorkPositions">
                                                    <label class="form-check-label"
                                                        [for]="exclWork.workId">{{exclWork.workText}}
                                                    </label>
                                                </div>
                                            </div>

                                            <div class="mt-2 mb-3 mx-3">
                                                <app-tec-rmi-part-detail [tecDocType]="tecDocType"
                                                    *ngIf="item.showParts == true" [workStepId]="item.workId"
                                                    [workPartList]="item.parts" (addCartPart)="addPartToCart($event)"
                                                    (removeCartPart)="removePartFromCart($event)"
                                                    (setPartsToWork)="setPartListForWork($event)">
                                                </app-tec-rmi-part-detail>
                                            </div>

                                           

                                        </div>


                                    </div>
                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>
                    </div>
                </div>
            </ng-cotainer>

            <!-- CheckOut -->
            <ng-cotainer *ngIf="selectedtab==5">
                <div class="pad15 ctm-tab custom-card">
                    <div class="card-accord">
                        <ngb-accordion #b="ngbAccordion" [activeIds]="openPanels">
                            <ngb-panel id="first-panel">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="btn w-100 align-items-center text-left">

                                        <div class="form-row d-flex align-items-center">
                                            <div class="col-auto wd-50">
                                                <button ngbPanelToggle class="" aria-label="Center Align">
                                                    <ng-container *ngIf="!b.activeIds.includes('first-panel')"><em
                                                            class="fas fa-angle-down font20 ml-auto"></em>
                                                    </ng-container>
                                                    <ng-container *ngIf="b.activeIds.includes('first-panel')"><em
                                                            class="fas fa-angle-up font20 ml-auto"></em>
                                                    </ng-container>
                                                </button>
                                            </div>
                                            <div class="col-md-4 txt" translate>
                                                lblMainService
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblHours
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblPrice
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblSum
                                            </div>
                                            <div class="col-auto ml-auto txt" style="padding-right: 6px;">
                                                Action
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <ul>
                                        <li *ngFor="let item of AddedServicesInCart">
                                            <div class="form-row">
                                                <div class="col-auto wd-50">
                                                    <img src="../../../../../assets/images/no-image-icon.png" width="40"
                                                        alt="">
                                                </div>
                                                <div class="col-md-4">
                                                    <p class="font16 bold">{{item.workText}}</p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="font14">{{item.workTime}} h</p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="font14">€ 0</p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="bold font14">€ 0</p>
                                                </div>
                                                <div class="col-auto ml-auto" style="padding-right: 6px;">
                                                    <button class="btn btn-ico" aria-label="Center Align"
                                                        (click)="removeMainService(item)">
                                                        <em class="far fa-trash-alt fa-lg"></em>
                                                    </button>
                                                </div>
                                            </div>

                                        </li>
                                    </ul>
                                </ng-template>
                            </ngb-panel>
                            <ngb-panel id="third-panel">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="btn w-100 align-items-center text-left">

                                        <div class="form-row d-flex align-items-center">
                                            <div class="col-auto wd-50">
                                                <button ngbPanelToggle class="" aria-label="Center Align">
                                                    <ng-container *ngIf="!b.activeIds.includes('third-panel')"><em
                                                            class="fas fa-angle-down fa-lg ml-auto"></em>
                                                    </ng-container>
                                                    <ng-container *ngIf="b.activeIds.includes('third-panel')"><em
                                                            class="fas fa-angle-up fa-lg ml-auto"></em>
                                                    </ng-container>
                                                </button>
                                            </div>
                                            <div class="col-md-4 txt" translate>
                                                lblTecRMIParts
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblQuantity
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblPrice
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblSum
                                            </div>
                                            <div class="col-auto ml-auto txt" style="padding-right: 6px;">
                                                Action
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <ul>
                                        <li *ngFor="let item of cartPartItems">
                                            <div class="form-row">
                                                <div class="col-auto wd-50">
                                                    <img src="../../../../../assets/images/no-image-icon.png" width="40"
                                                        alt="">
                                                </div>
                                                <div class="col-md-4">
                                                    <p class="font16 bold">{{item.partName}}</p>
                                                    <p> <label translate>lblPartNumber </label> <label class="bold"> :
                                                            {{item.partNo}}</label></p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="font14">{{item.qty}}{{item.qtyType}}</p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="font14">€ 0</p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="bold font14">€ 0</p>
                                                </div>
                                                <div class="col-auto ml-auto" style="padding-right: 6px;">
                                                    <button class="btn btn-ico" aria-label="Center Align"
                                                        (click)="removePartFromCart(item)">
                                                        <em class="far fa-trash-alt fa-lg"></em>
                                                    </button>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>
                    </div>
                </div>
            </ng-cotainer>

            <!-- Stock Balance -->
            <ng-cotainer *ngIf="selectedtab==6">
                <div class="pad15 ctm-tab custom-card">
                    <div class="card-accord">
                        <ngb-accordion #b="ngbAccordion" [activeIds]="openPanels">
                            <ngb-panel id="first-panel">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="btn w-100 align-items-center text-left">

                                        <div class="form-row d-flex align-items-center">
                                            <div class="col-auto wd-50">
                                                <button ngbPanelToggle class="" aria-label="Center Align">
                                                    <ng-container *ngIf="!b.activeIds.includes('first-panel')"><em
                                                            class="fas fa-angle-down font20 ml-auto"></em>
                                                    </ng-container>
                                                    <ng-container *ngIf="b.activeIds.includes('first-panel')"><em
                                                            class="fas fa-angle-up font20 ml-auto"></em>
                                                    </ng-container>
                                                </button>
                                            </div>
                                            <div class="col-md-4 txt" translate>
                                                lblArticle
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblKahaStock
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblLocalStock
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblUnitPrice
                                            </div>
                                            <div class="col-auto ml-auto txt" style="padding-right: 6px;">
                                                lblAction
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <ul>
                                        <li *ngFor="let item of availableStockBalance">
                                            <div class="form-row">
                                                <div class="col-auto wd-50">
                                                    <img src="../../../../../assets/images/no-image-icon.png" width="40"
                                                        alt="">
                                                </div>
                                                <div class="col-md-4">
                                                    <p class="font16 bold">{{item.name}}</p>
                                                    <p> <label translate>Article No</label> <label> :
                                                            {{item.number}}</label></p>
                                                    <div *ngIf="item.exclusiveWorkPositions && item.exclusiveWorkPositions.length > 0"
                                                        class="mt-3 mb-3">
                                                        <h4 class="bold font14">Contains</h4>

                                                        <p class="font14"
                                                            *ngFor="let exclWork of item.exclusiveWorkPositions"
                                                            [id]="exclWork.workId">
                                                            {{exclWork.workLabourInfoText}}

                                                        </p>

                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="font14">{{item.stockLevel}} </p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="font14">{{item.localStock}}</p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="bold font14">{{item.listPrice}}</p>
                                                </div>
                                                <div class="col-auto ml-auto" style="padding-right: 6px;">
                                                    <div class="form-check pl-0">
                                                        <input type="checkbox"
                                                            id="addRemoveArticleToCart{{item.number}}"
                                                            (change)="addRemoveArticleToCart($event,item)"
                                                            [(ngModel)]="item.isChecked" />
                                                    </div>
                                                </div>
                                            </div>

                                        </li>
                                    </ul>
                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>
                    </div>
                </div>
            </ng-cotainer>
        </div>
    </div>

</div>
<div class="modal-footer" style="align-items: normal;    flex-flow: column;">
    <div class="row">
        <div class="col-auto">
            <button type="button" class="btn btn-primary" translate (click)="showPreviousTab()">lblPrevious</button>
        </div>
        <div class="col-auto ml-auto">
            <button type="button" class="btn btn-primary" [disabled]="
                (selectedtab == 1 && (selectedLabourWorkFromStep1 == null || selectedLabourWorkFromStep1 == undefined )) || 
                (selectedtab == 2 && isStep2Completed == false)|| 
                (selectedtab == 3 && isStep3Completed == false) || 
                (selectedtab == 4 && AddedServicesInCart.length <= 0) "
                translate (click)="showNextTab()">lblNext
                <em class="fa-solid fa-angles-right"></em>
            </button>
        </div>
    </div>
</div>